module.exports = __webpack_public_path__ + "static/media/toscany.37269ee8.jpg";